export default {
	title: 'हितधारक',
	context_best: 'अनुकूल',
	context_worse: 'प्रतिकूल',
	zones: {
		positive: 'अनुकूल',
		positive_line2: 'क्षेत्र',
		neutral: 'तटस्थ',
		negative: 'प्रतिकूल',
		negative_line2: 'क्षेत्र',
		point_of_view_line1: 'दृष्टि',
		point_of_view_line2: 'कोण',
		point_of_view_line3: ''
	},
	alignment: {
		title_1: 'हितधारक',
		title_2: 'संरेखण'
	},
	tabs: {
		general: {
			title: 'सामान्य'
		},
		links: {
			title: 'लिंक'
		},
		comments: {
			title: 'इतिहास'
		},
		filters: {
			title: 'दृश्य फ़िल्टर'
		},
		export: {
			title: 'निर्यात',
			image: 'रडार को छवि के रूप में निर्यात करें'
		},
		risks: {
			title: 'जोखिम'
		},
		bot: {
			title: 'बुद्धिमत्ता'
		},
		tags: {
			title: 'टैग',
			assigned: 'निर्दिष्ट टैग',
			unassigned: 'अनिर्दिष्ट टैग'
		},
		disabled: {
			title: 'अक्षम'
		}
	},
	summary: {
		key_drivers: 'मुख्य चालक',
		scenario_score: 'परिदृश्य स्कोर',
		max_value: 'अधिकतम {{value}}',
		legend: {
			current: 'वर्तमान',
			scenario: 'परिदृश्य'
		}
	},
	all_tags: 'टैग फ़िल्टर',
	links: 'सभी लिंक दिखाएँ',
	no_tag: 'कोई टैग नहीं',

	all_icons: 'आइकन फ़िल्टर',
	no_icon: 'कोई आइकन नहीं',

	all_stakes: 'हित फ़िल्टर',
	all_constraints: 'संकेतक फ़िल्टर',
	all_risks: 'जोखिम फ़िल्टर',
	all_opportunities: 'ओपनिंग फ़िल्टर',
	onboarding: {
		title: 'हितधारकों की समीक्षा',
		description:
			'आपके विषय पर भार डालने वाले अभिनेता रडार पर उनके प्रभाव और रवैये के अनुसार स्थित हैं। संरेखण जाँचें और यदि आपकी पठन भिन्न हो तो समायोजित करें।'
	}
};
